//export const baseURL = "http://127.0.0.1:8000/";
export const baseURL = "http://admin.networkresilience.co.zw/";